// Importaciones de componentes
import FeaturedProducts from "./FeaturedProducts";
import Hero from "./Hero";
import Categories from "./Categories";
import HomeBento from "./HomeBento";
import BrandsFeature from "./features/BrandsFeature";
import TestimonialsSection from "./testimonials";
import bolsaIcon from "/images/svg/bolsa-icon.svg";
import moleculaIcon from "/images/svg/molecula-icon.svg";
import huesoIcon from "/images/svg/hueso-icon.svg";
import { CatalogosSection } from "./features/CatalogosSection";
import StoreLocatorCTA from "./StoreLocatorCTA";
import { T } from "@tolgee/react";

// Importar los componentes de Medusa cuando sea necesario
/* Estos serán implementados más adelante
import FeaturedProducts from "@modules/products/components/featured-products"
import Hero from "@modules/layout/components/hero"
import AppleStyleFeatures from "./features/apple-style-features"
import FeaturedCollections from "./featured-collections"
import Newsletter from "@modules/newsletter/components/newsletter" 
*/

// Verificar si estamos en entorno de desarrollo - alternativa segura a process.env
const isDevelopment = () => {
  // Comprobar si estamos en desarrollo basado en URL o características del navegador
  return window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.port === '3000' ||
    window.location.port === '5173';
};

// Componente de ventajas similar al diseño de la imagen
const AdvantagesSection = () => {
  const advantages = [
    {
      icon: bolsaIcon,
      titleKey: "home.advantages.nutrition.title",
      descriptionKey: "home.advantages.nutrition.description",
      title: "Nutrición natural",
      description: "Desarrollamos fórmulas completas elaboradas con ingredientes naturales, pensadas para favorecer la salud digestiva, el bienestar general y la vitalidad de las mascotas."
    },
    {
      icon: moleculaIcon,
      titleKey: "home.advantages.development.title",
      descriptionKey: "home.advantages.development.description",
      title: "Desarrollo propio",
      description: "Creamos nuestras propias recetas adaptadas a las necesidades nutricionales de cada especie, tamaño y etapa de vida, garantizando una alimentación precisa y equilibrada."
    },
    {
      icon: huesoIcon,
      titleKey: "home.advantages.experience.title",
      descriptionKey: "home.advantages.experience.description",
      title: "Experiencia",
      description: "Innovamos con nuevos productos adaptados a las tendencias del sector (alimentación funcional, snacks naturales, etc.)"
    }
  ];

  return (
    <div className="py-16 bg-[#f2ede4]">
      <hr className="border-t-2 border-gray-200 my-8" />
      <div className="content-container">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold mb-4" style={{ color: '#0d0d0d' }}>
            <T keyName="home.advantages.title">COMPROMÉTETE CON EL BIENESTAR ANIMAL</T>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {advantages.map((advantage, index) => (
            <div key={index} className="text-left">
              <div
                className="w-16 h-16 mr-auto mb-4 rounded-full flex items-start justify-start text-2xl"
                style={{ backgroundColor: '#f6cf02' }}
              >
                <img src={advantage.icon} alt={advantage.title} className="w-full h-full" />
              </div>
              <h3 className="font-bold text-lg mb-2" style={{ color: '#0d0d0d' }}>
                <T keyName={advantage.titleKey}>{advantage.title}</T>
              </h3>
              <p className="text-gray-600 text-sm">
                <T keyName={advantage.descriptionKey}>{advantage.description}</T>
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const ClientHomeSections = () => {
  return (
    <div className="flex flex-col relative">
      {/* Hero Section */}
      <div className="w-full">
        <Hero />
      </div>

      {/* Categorías de productos - Nueva sección similar a la imagen */}
      <Categories />

      <HomeBento />

      {/* Sección de productos destacados */}
      <div className="py-12 lg:pt-16 lg:pb-24">
        <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold tracking-tight" style={{ color: '#0d0d0d' }}>
              <T keyName="home.new_products.title">Novedades</T>
            </h2>
          </div>
          <FeaturedProducts />
        </div>
      </div>

      {/* Ventajas/Características - Nueva sección */}
      <AdvantagesSection />

      {/* Sección de marcas Jarad */}
      <div className="">
        <BrandsFeature />
      </div>
      
      {/* CTA del Mapa de Tiendas */}
      <StoreLocatorCTA />

      <CatalogosSection />
      {/* Catálogos */}

      {/* Testimonios */}
      <div className="py-16">
        <div className="content-container">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold tracking-tight" style={{ color: '#0d0d0d' }}>
              <T keyName="home.testimonials.title">Nuestros clientes opinan</T>
            </h2>
            <p className="mt-4 max-w-xl mx-auto text-base text-gray-500">
              <T keyName="home.testimonials.subtitle">Descubre lo que dicen sobre nosotros</T>
            </p>
          </div>
          <TestimonialsSection />
        </div>
      </div>

      {/* Newsletter con fondo negro */}


      {/* Componentes de diagnóstico - solo para desarrollo */}
      {isDevelopment() && (
        <div className="fixed bottom-0 right-0 m-4 z-50">
          <button className="bg-black text-white px-4 py-2 rounded-full text-xs flex items-center space-x-2 opacity-50 hover:opacity-100 transition-opacity">
            <span className="inline-block w-2 h-2 rounded-full bg-green-500"></span>
            <span><T keyName="home.development_mode">Modo Desarrollo Activo</T></span>
          </button>
        </div>
      )}
    </div>
  );
};

export default ClientHomeSections; 
